<template>
  <v-list-item-icon v-if="isGuest">
      <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="primaryDark"
              v-bind="attrs"
              v-on="on"
              x-small
              @click="updateAttendee(attendee)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>

          </template>
          <span>{{ $t("agenda.UpdateGuestAttendeeData") }}</span>
        </v-tooltip>
        <UpdateAttendeeData v-if="isUpdateAttendee" v-model="isUpdateAttendee" @data="updatedData" :attendee="attendee" />
    </v-list-item-icon>
</template>

<script>
import { mapState } from "vuex";
import UpdateAttendeeData from "./UpdateAttendeeData.vue";
export default {
  name: "UpdateGuestAttendee",
  components: {
    UpdateAttendeeData
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    attendee: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isUpdateAttendee: false,
    };
  },
  computed: {
    ...mapState({
      userList: (state) => state.people.userList,
      deletedUserList: (state) => state.meeting.deletedUserList,
    }),
    allUsers(){
      return [...this.userList, ...this.deletedUserList];
    },
    isGuest(){
      const users = this.allUsers.filter(u =>
          (!u.firstName || u.firstName.trim() === "") &&
          (!u.lastName || u.lastName.trim() === "") &&
          u.display_email &&
          u.is_deleted === true &&
          u.is_registered_user === false &&
          u.is_listed_in_people === false && (u.id === this.attendee.id)
      );
      return users.length > 0;
    }

  },
  mounted(){
  },
  methods: {
    updateAttendee() {
      this.isUpdateAttendee = true;
    },
    updatedData(data){
      this.attendee.firstName = data.firstName;
      this.attendee.lastName = data.lastName;
      this.attendee.title = data.title;
      this.attendee.isGuest = this.isGuest;
      this.$emit("updatedData", this.attendee);
    },
  },
};
</script>
